import React from "react";

import type { Integration } from "@app/common/types";
import Config from "@app/config";

import Button from "@rui/Button";
import GoogleButton from "@rui/GoogleButton";
import Link from "@rui/Link";
import TooltipWrapper from "@rui/TooltipWrapper";

interface ConnectCtaProps {
  cta: {
    href?: string;
    isLoading?: boolean;
    label?: string;
    onClick?: () => void;
    disabled?: boolean;
    show?: boolean;
    tooltip?: string;
  };
  provider: Integration;
}

const DEFAULT_DISABLED_CTA_TOOLTIP =
  "Your Workspace has restricted access to this integration. It is not available to use with Read at this time.";

const ConnectCta = ({ cta, provider }: ConnectCtaProps) => {
  const isConnectDisabled = provider.isDisabled || Boolean(cta.disabled);
  const label =
    cta.label ??
    (Config.flags.googleReview
      ? `Connect with ${provider.displayNameShort}`
      : "Connect");

  return (
    <TooltipWrapper
      title={provider.isDisabled ? DEFAULT_DISABLED_CTA_TOOLTIP : cta.tooltip}
      show={provider.isDisabled || Boolean(cta.disabled && cta.tooltip)}
    >
      {Config.flags.googleReview ? (
        <GoogleButton
          component={Link}
          disabled={isConnectDisabled}
          startIcon={<img src={provider.icon} alt={label} />}
          href={cta.href}
          onClick={cta.onClick}
          sx={{ flexShrink: 0 }}
        >
          {label}
        </GoogleButton>
      ) : (
        <Button
          component={Link}
          disabled={isConnectDisabled}
          loading={cta.isLoading}
          href={cta.href}
          onClick={cta.onClick}
          sx={{ minWidth: "100px", flexShrink: 0 }}
        >
          {label}
        </Button>
      )}
    </TooltipWrapper>
  );
};

export default ConnectCta;
